import type { PrimitiveType } from '#layers/data-model/types/schema/primitive-type';
import { isPrimitiveTypeBoolean, isPrimitiveTypeFloat, isPrimitiveTypeInteger, isPrimitiveTypeJson } from '#layers/data-model/utils/schema/primitive-type';

export function serializeRawValue(value: unknown, type: PrimitiveType): string {
	if (value === null || value === undefined) return '';
	if (isPrimitiveTypeJson(type)) return JSON.stringify(value, null, 2);
	return String(value);
}

export function parseRawValue(text: string, type: PrimitiveType): unknown {
	if (text === '') return null;
	if (isPrimitiveTypeInteger(type)) return Number.parseInt(text, 10);
	if (isPrimitiveTypeFloat(type)) return Number.parseFloat(text);
	if (isPrimitiveTypeBoolean(type)) return text === 'true' || text === '1';
	if (isPrimitiveTypeJson(type)) return JSON.parse(text);
	return text;
}

export function validateRawValue(text: string, type: PrimitiveType): string | undefined {
	if (!isPrimitiveTypeJson(type)) return undefined;
	if (text === '') return undefined;

	try {
		JSON.parse(text);
		return undefined;
	}
	catch {
		return 'errors.invalid_json';
	}
}
